module.exports = __webpack_public_path__ + "b67f7646a9491e9fe14f84f32b41ba21.svg";